import axios from "axios";
import { create } from "zustand";

const categoryStore = create((set) => ({
  mCategory: null,
  category: null,
  womenCategory: null,
  menCategory: null,
  kidsCategory: null,

  fetchAllCategory: async () => {
    // Fetch Category
    const res = await axios.get("/site/fetch-all-category");
    // set category to state
    set({ mCategory: res.data.category, category: res.data.category });
  },

  setGenderWishCategory: async () => {
    const { category } = categoryStore.getState();
    const genders = ["W", "M", "K"];
    genders.map((gender) => {
      const data = [];
      category.filter((item) => {
        if (item.status === "A") {
          if (gender === "W") {
            item.isWomenImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfWomen,
              });
          }
          if (gender === "M") {
            item.isMenImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfMen,
              });
          }
          if (gender === "K") {
            item.isKidsImage === true &&
              data.push({
                _id: item._id,
                categoryName: item.categoryName,
                categoryImage: item.categoryImageOfKids,
              });
          }
        }
      });

      if (gender === "W") {
        set({ womenCategory: data });
      }
      if (gender === "M") {
        set({ menCategory: data });
      }
      if (gender === "K") {
        set({ kidsCategory: data });
      }
    });
  },
}));

export default categoryStore;
